import { Box, Checkbox, FormControlLabel } from "@mui/material"
import type { FC } from "react"

import { INVOICE_TYPE_LABELS } from "../../constants/labels"

import { InvoiceType } from "@/graphql/codegen/graphql"

const INVOICE_TYPE_LIST = Object.values(InvoiceType)

interface InvoicesTransactionTypeFilterProps {
  invoiceType: InvoiceType | undefined
  onChange: (invoiceType: InvoiceType | undefined) => void
}

export const InvoicesTransactionTypeFilter: FC<InvoicesTransactionTypeFilterProps> = ({ invoiceType, onChange }) => {
  const handleToggle = (clicked: InvoiceType) => {
    onChange(invoiceType === clicked ? undefined : clicked)
  }

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      {INVOICE_TYPE_LIST.map((type) => (
        <FormControlLabel
          key={type}
          control={
            <Checkbox
              checked={invoiceType === type}
              onChange={() => handleToggle(type)}
              data-testid={`invoices.filter-drawer.transaction-type-checkbox-${type}`}
            />
          }
          label={INVOICE_TYPE_LABELS[type]}
          className='w-full text-ellipsis'
        />
      ))}
    </Box>
  )
}
